import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule, MatFormFieldModule, MatInputModule,
    MatListModule,
    MatRadioModule,
    MatSelectModule
} from '@angular/material';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxPopperModule } from 'ngx-popper';
import { FormatrutPipe } from 'src/app/global/pipes/formatrut.pipe';
import { SharedModule } from 'src/app/shared/shared.module';
import { CarroCompraComponent } from 'src/app/shared/ui/carro-compra/carro-compra.component';
import { ResumenCompraComponent } from '../../pages/resumen-compra/resumen-compra/resumen-compra.component';
import { ProductsWrapperComponent } from '../shopping-cart/products-wrapper/products-wrapper.component';
import { ShoppingCartModule } from '../shopping-cart/shopping-cart.module';
import { PasoDosComponent } from './paso-dos/paso-dos.component';
import { ConfiguracionProductoPJComponent } from './paso-dos/persona-juridica/configuracion-producto-pj/configuracion-producto-pj.component';
import { CuentaBancariaPJComponent } from './paso-dos/persona-juridica/cuenta-bancaria-pj/cuenta-bancaria-pj.component';
import { DatosEmpresaComponent } from './paso-dos/persona-juridica/datos-empresa/datos-empresa.component';
import { DatosSocioComponent } from './paso-dos/persona-juridica/datos-socio/datos-socio.component';
import { DeclaracionJuradaComponent } from './paso-dos/persona-juridica/declaracion-jurada/declaracion-jurada.component';
import { FormUafComponent } from './paso-dos/persona-juridica/declaracion-jurada/form-uaf/form-uaf.component';
import { ConfiguracionProductoComponent } from './paso-dos/persona-natural/configuracion-producto/configuracion-producto.component';
import { CuentaBancariaComponent } from './paso-dos/persona-natural/cuenta-bancaria/cuenta-bancaria.component';
import { DatosAdjuntosComponent } from './paso-dos/persona-natural/datos-adjuntos/datos-adjuntos.component';
import { DatosComercioComponent } from './paso-dos/persona-natural/datos-comercio/datos-comercio.component';
import { DatosPersonalesCiComponent } from './paso-dos/persona-natural/datos-personales-ci/datos-personales-ci.component';
import { DatosPersonalesComponent } from './paso-dos/persona-natural/datos-personales/datos-personales.component';
import { ConfiguraProductoCompartidoComponent } from './paso-dos/shared/configura-producto-compartido/configura-producto-compartido.component';
import { ConfiguraProveedorServicioTecnologicoComponent } from './paso-dos/shared/configura-proveedor-servicio-tecnologico/configura-proveedor-servicio-tecnologico.component';
import { AbonosComponent } from './paso-tres/abonos/abonos.component';
import { CuotasTbkComponent } from './paso-tres/cuotas-tbk/cuotas-tbk.component';
import { DatosEntregaComponent } from './paso-tres/datos-entrega/datos-entrega.component';
import { FirmarDocumentosComponent } from './paso-tres/firmar-documentos/firmar-documentos/firmar-documentos.component';
import { PasoTresComponent } from './paso-tres/paso-tres.component';
import { AbonosPJComponent } from './paso-tres/persona-juridica/abonos/abonos-pj.component';
import { TerminosCondicionesComponent } from './paso-tres/terminos-condiciones/terminos-condiciones.component';
import { LoginUnificadoComponent } from './paso-uno-login/login-unificado/login-unificado.component';
import { PasoUnoLoginComponent } from './paso-uno-login/paso-uno-login.component';
import { PersonaJuridicaLoginComponent } from './paso-uno-login/persona-juridica-login/persona-juridica-login.component';
import { PersonaNaturalLoginComponent } from './paso-uno-login/persona-natural-login/persona-natural-login.component';
import { PasoUnoComponent } from './paso-uno/paso-uno.component';
import { PersonaJuridicaComponent } from './paso-uno/persona-juridica/persona-juridica.component';
import { PersonaNaturalComponent } from './paso-uno/persona-natural/persona-natural.component';
import { SteppersRoutingModule } from './steppers-routing.module';
import { SteppersComponent } from './steppers.component';
@NgModule({
    declarations: [
        AbonosComponent,
        AbonosPJComponent,
        ConfiguracionProductoComponent,
        ConfiguracionProductoPJComponent,
        CuentaBancariaComponent,
        CuentaBancariaPJComponent,
        CuotasTbkComponent,
        DatosAdjuntosComponent,
        DatosComercioComponent,
        DatosEmpresaComponent,
        DatosEntregaComponent,
        DatosPersonalesCiComponent,
        DatosPersonalesComponent,
        DatosSocioComponent,
        DatosSocioComponent,
        DeclaracionJuradaComponent,
        FirmarDocumentosComponent,
        FormUafComponent,
        FormatrutPipe,
        LoginUnificadoComponent,
        PasoDosComponent,
        PasoTresComponent,
        PasoUnoComponent,
        PasoUnoLoginComponent,
        PersonaJuridicaComponent,
        PersonaJuridicaLoginComponent,
        PersonaNaturalComponent,
        PersonaNaturalLoginComponent,
        ResumenCompraComponent,
        SteppersComponent,
        TerminosCondicionesComponent,
        ConfiguraProductoCompartidoComponent,
        ConfiguraProveedorServicioTecnologicoComponent
    ],
    imports: [
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatProgressBarModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatStepperModule,
        NgxMatSelectSearchModule,
        NgxPopperModule.forRoot({}),
        SharedModule,
        ShoppingCartModule,
        SteppersRoutingModule,
        MatListModule
    ],
    exports: [
        CarroCompraComponent,
        PasoDosComponent,
        PasoTresComponent,
        PasoUnoComponent,
        ProductsWrapperComponent,
        SteppersComponent,
        SteppersRoutingModule
    ]
})
export class SteppersModule { }
